import { authHeader } from '../../_helpers';
import axios from 'axios';

export const creditOrgService = {
    getOrgCreditList
};
axios.defaults.headers.common = authHeader();

function getOrgCreditList(id, org) {
  
    return axios.get(`/users/organisation/assessment/credit/list/${id}/${org}/`)
        .then(response => {
            return response;
        });
}


// WEBPACK FOOTER //
// ./src/_services/organisation/credits.service.js